import { render, staticRenderFns } from "./WorkshopClientReplaceParticipant.vue?vue&type=template&id=69516502&"
import script from "./WorkshopClientReplaceParticipant.vue?vue&type=script&lang=ts&"
export * from "./WorkshopClientReplaceParticipant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports